import { render, staticRenderFns } from "./KidIcon.vue?vue&type=template&id=1c9ca425&"
import script from "./KidIcon.vue?vue&type=script&lang=js&"
export * from "./KidIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports